import styled from 'styled-components'
import { Button, Card } from '@/ui/components'
import { FormattedMessage } from 'react-intl'
import { strings } from './Pricing.strings'

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
`
const PriceContainer = styled(Card)`
  display: flex;
  flex-direction: column;
`
// TODO: Move this to a db so we can update and pull accordingly
interface Plan {
  id: string
  sku: string
  title: string
  description: string
  features: string[]
  price: string
}

/**
 * Need to think about what kind of plans I want, thinking:
 * 1. Digital only
 * 2. Print, but cost is variable, based on pages and size - this may need to be a calculator thing to "predict cost" or it can be
 * discounted digital cost plus book size base price with 20 pages + cost of each additional page. this may need to be a list or each one
 * can be its on standalone plan
 * 3. Discount for more books purchased at once
 */
const pricingPlans: Plan[] = [
  {
    id: '123',
    sku: 'basic',
    title: 'The Digital',
    description:
      'The most humble of our options and for those who need a physical book',
    features: ['Digital book only', 'Downloadable PDF copy'],
    price: '15.99',
  },
]
/**
 * This page will be shown and interacted with in two spots:
 * 1. A user can view the pricing from the home page and select a plan which will lead into an onboarding flow
 * 2. If the user clicks "Create Event"
 */
export const Pricing: React.FC = () => {
  return (
    <Container>
      <h1>
        <FormattedMessage {...strings.title} />
      </h1>
      <p>
        <FormattedMessage {...strings.description} />
      </p>
      {pricingPlans.map((plan) => {
        return (
          <PriceContainer key={plan.id}>
            <h3>{plan.title}</h3>
            <p>{plan.description}</p>
            <ul>
              {plan.features.map((f) => (
                <li key={f}>{f}</li>
              ))}
            </ul>
            <p>{`$${plan.price}`}</p>
            <Button
              onClick={() => console.log(`Buying the ${plan.sku} snitch`)}
            >
              Select
            </Button>
          </PriceContainer>
        )
      })}
    </Container>
  )
}
